import { Component } from '@angular/core';

@Component({
  selector: 'app-buildingimages-link',
  templateUrl: './buildingimages-link.component.html',
  styleUrls: ['./buildingimages-link.component.scss']
})
export class BuildingimagesLinkComponent {

}
